var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    viewBox: "0 0 12 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86692 24.2099L10.0369 16.0399C10.5026 15.5755 10.872 15.0237 11.124 14.4163C11.3761 13.8088 11.5059 13.1576 11.5059 12.4999C11.5059 11.8423 11.3761 11.1911 11.124 10.5836C10.872 9.97615 10.5026 9.4244 10.0369 8.95994L1.86692 0.789941C1.67862 0.601637 1.42322 0.495849 1.15692 0.495849C0.890619 0.495849 0.635226 0.601637 0.446922 0.789941C0.258618 0.978244 0.15283 1.23364 0.15283 1.49994C0.15283 1.76624 0.258618 2.02164 0.446922 2.20994L8.61692 10.3799C9.17872 10.9424 9.49428 11.7049 9.49428 12.4999C9.49428 13.2949 9.17872 14.0574 8.61692 14.6199L0.446921 22.7899C0.353193 22.8829 0.278797 22.9935 0.228028 23.1154C0.177259 23.2372 0.151122 23.3679 0.151122 23.4999C0.151122 23.632 0.177259 23.7627 0.228028 23.8845C0.278797 24.0064 0.353193 24.117 0.446921 24.2099C0.539884 24.3037 0.650484 24.3781 0.772344 24.4288C0.894203 24.4796 1.02491 24.5057 1.15692 24.5057C1.28893 24.5057 1.41964 24.4796 1.5415 24.4288C1.66336 24.3781 1.77396 24.3037 1.86692 24.2099Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.6c8cc707d725c9eb800c765a97400651.svg";
export { ForwardRef as ReactComponent };